






































































import Vue from 'vue';
import { WithRefs } from 'vue-typed-refs';

import SldsSpinnerContainer from '../Spinner/SpinnerContainer.vue';

import { hasSlot } from '../../util';

export type Refs = {
  body: HTMLDivElement;
};

export default (Vue as WithRefs<Refs>).extend({
  components: {
    SldsSpinnerContainer,
  },
  props: {
    id: { type: String, default: undefined },
    title: { type: String, default: undefined },
    titleTag: { type: String, default: 'h2' },
    loading: { type: Boolean, default: false },
    boundary: { type: Boolean, default: false },
    noContentPadding: { type: Boolean, default: false },
    bodyClass: { type: [String, Object, Array], default: undefined },
    footerClass: { type: [String, Object, Array], default: undefined },
  },
  computed: {
    hasHeader(): boolean {
      return (
        this.title !== undefined ||
        this.hasSlot('title') ||
        this.hasSlot('buttons')
      );
    },
    hasBodyPadding(): boolean {
      return !this.noContentPadding;
    },
  },
  methods: {
    hasSlot,
  },
});
